import {Transaction, AmountModification} from '../domain/Transaction'

export const applyAmountModification = (
  transaction: Transaction,
  newAmount: number,
  justification: string,
  timestamp: string,
): Transaction => {
  const entry: AmountModification = {
    previousAmount: transaction.amount,
    newAmount,
    justification,
    timestamp,
  }
  return {
    ...transaction,
    amount: newAmount,
    amountModifications: [...(transaction.amountModifications ?? []), entry],
  }
}
